import React from 'react'
import NavigationMenu_ProjectsTree from "./tree/projects-tree"
import NavigationMenu_ProjectsTags from "../tags/tags"
import NavigationMenu_ProjectsTagsGroup from "../tags/tags-group"
import {TAGS_AS_TREE_GROUP} from "../tags/@const"
import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import NavigationMenu_SpacePreferences from "../../components/space-preferences/preferences"
import NavigationMenuProjectsViewsV2 from "./views/views-v2"
import {EVENT_BUS_MENU_SORT_CHANGED, EVENT_BUS_MENU_SORT_RESET, MenuComponentProps} from "../const"
import {
    BUS_TREE_CHANGE,
    BUS_USER_CHANGE,
    SESSION_COMPANY_SETTINGS_CHANGED,
    SESSION_PROJECT_CHANGE,
    SESSION_STARRED_CHANGED
} from "../../../../core/gd/bus/bus-event-type"
import NavigationMenuSection from "../../menu-items/section/section"
import NavigationMenu_StarredProjects from "../../components/starred/starred-projects"
import {ProjectsTreeSortType} from "../../../../core/model2/space/@types";
import spacePreferences_PopoverMenuOptions from "../../actions/space-preferences-menu-options";
import {UIType} from "../../../ui/@const";

// const debug = "MenuProjects"
const debug = false

export default class NavigationMenu_ProjectsContent extends React.Component<MenuComponentProps,any> {



    public localSettings    : NavigationMenu_ProjectsLocalSettings


    constructor(props:MenuComponentProps) {
        super(props)

        this.localSettings  = new NavigationMenu_ProjectsLocalSettings()

    }

    componentDidMount() {
        // gd.router.on('route', this.onRoute);
        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.onTreeChange)
        gd.bus.subscribe(SESSION_COMPANY_SETTINGS_CHANGED, this, this.onCompanySettingsChange)
        gd.bus.subscribe(BUS_USER_CHANGE, this, this.onUserSettingsChange)

        // need it on this level as we separate stars and all projects
        gd.bus.subscribe(SESSION_STARRED_CHANGED, this, this.onSessionStarredChanged)
        gd.bus.subscribe(EVENT_BUS_MENU_SORT_CHANGED, this, this.onSortTypeChange)
        gd.bus.subscribe(EVENT_BUS_MENU_SORT_RESET, this, this.onSortDefaultReset)
        gd.bus.subscribe(SESSION_PROJECT_CHANGE, this, this.sessionProjectChanged)

    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onTreeChange = () => {
        debug && console.log(debug, 'onTreeChange')

        this.forceUpdate()
    }

    onCompanySettingsChange = () => {
        debug && console.log(debug, 'onCompanySettingsChange')

        this.forceUpdate()
    }

    onUserSettingsChange = () => {
        debug && console.log(debug, 'onUserSettingsChange')

        this.forceUpdate()
    }

    onSessionStarredChanged = () => {
        debug && console.log(debug, 'onSessionStarredChanged')

        this.forceUpdate()
    }

    onSortTypeChange = (value:ProjectsTreeSortType) => {
        debug && console.log(debug, 'onSortTypeChange', value)

        this.localSettings.sortType = value
        this.localSettings.save()

        this.forceUpdate()
    }

    onSortDefaultReset = () => {
        debug && console.log(debug, 'onSortDefaultReset')
        gd.user.menu.projectsAll.sortedMap = {}
        gd.user.menu.save()

        this.forceUpdate()
    }

    sessionProjectChanged = (projectId: ID) => {
        if (gd.spaces.projects.id === gd.session.projects.get(projectId)?.space.id) {
            this.forceUpdate()
        }
    }

    reRender = ()=> {
        this.forceUpdate()
    }

    render() {

        const rootTags = gd.session.projects.rootTags

        debug && console.log(debug, 'render rootTags=', rootTags)


        const controls = (
            <NavigationMenu_SpacePreferences className      = "m-r-5"
                                             space          = {gd.spaces.projects}
                                             localSettings  = {this.localSettings}
                                             onReset        = {this.reRender}/>
        )

        const displayResourcesHeader = (gd.layout.type !== UIType.ASANA)

        // rendered after the projects (before the "Everything" item)
        const tagsGroup = TAGS_AS_TREE_GROUP && rootTags?.length > 0
            ? <NavigationMenu_ProjectsTagsGroup showAdd={true} tags={rootTags}/>
            : null

        return (
            <>
                <NavigationMenu_StarredProjects
                    systemName  = "projects-starred"
                    space       = {gd.spaces.projects}
                />

                {displayResourcesHeader && (
                    <NavigationMenuSection name         = "Resources"
                                           collapsible  = {true}
                                           menuOptions  = {spacePreferences_PopoverMenuOptions(gd.spaces.projects, this.localSettings, this.reRender)}
                                           controls     = {controls}
                                           systemName   = "projects-resources"
                                           counter      = {gd.spaces.projects.menuResourcesCounter}>

                        <NavigationMenu_ProjectsTree localSettings  = {this.localSettings}
                                                     space          = {gd.spaces.projects}
                                                     endComponent   = {tagsGroup} />

                    </NavigationMenuSection>
                )}

                {!displayResourcesHeader && (
                    <NavigationMenu_ProjectsTree localSettings  = {this.localSettings}
                                                 space          = {gd.spaces.projects}
                                                 endComponent   = {tagsGroup} />
                )}



                {!TAGS_AS_TREE_GROUP && rootTags?.length > 0 &&
                    <NavigationMenu_ProjectsTags showAdd = {true}
                                                 tags    = {rootTags}/>
                }

                <NavigationMenuProjectsViewsV2 />
            </>
        )
    }
}
